"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  color: ", ";\n  margin: ", ";\n  line-height: 1.3;\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"], ["\n  font-family: ", ";\n  color: ", ";\n  margin: ", ";\n  line-height: 1.3;\n  ", ";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n"]);

var _styledComponents = require("styled-components");

var _buoyTheme = require("buoy-theme");

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Heading = (0, _styledComponents.css)(_templateObject, _buoyTheme.fontFamily, function (props) {
  return props.theme.colors[props.color];
}, function (props) {
  return props.margin;
}, function (props) {
  return props.textAlign && "text-align: " + props.textAlign;
});

exports.default = Heading;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-text/dist/components/Heading.js
// module id = 149
// module chunks = 168707334958949